import React from 'react';
import { DocumentTable } from './components';

const Analytics = () => {
  return <DocumentTable />;
};

export default Analytics;
